<template>
  <div class="d-flex flex-gap-32">
    <router-link v-for="item of items" :key="item.key" :to="{name: item.routeName}" class="directory-breadcrumb">
      {{item.name}}
    </router-link>
  </div>
</template>

<script>
import menuItems from '@/commons/menuItems';

export default {
  name: 'DirectoryBreadcrumbs',
  computed: {
    items() {
      return menuItems.find((item) => item.key === 'directory')?.subItems || [];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/styles/variables";
.directory-breadcrumb {
  margin-bottom: 18px;
  font-size: 20px;
  color: #BFC1C7;
  text-decoration: none;
  &.router-link-active {
    color: $base-color;
    font-weight: 700;
  }
}
</style>
